import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { TinyText } from '../../../legacy/hui/src/styled';

const MoreLabel = TinyText.extend`
  cursor: pointer;
  background: white;
  display: block;
  transition: all 0.2s ease-in;
  text-decoration: underline;
  text-align: right;
`;

const Collapse = styled.div`
  line-height: 1.2rem;
  max-height: 900rem;
  overflow: hidden;

  ${props =>
    props.collapsed &&
    css`
      max-height: 4.8em;
      position: relative;
      > ${MoreLabel} {
        top: 4rem;
      }

      &:after {
        bottom: 0;
        height: 30px;
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0), white);
        content: ' ';
        position: absolute;
        left: 0;
        right: 0;
        width: 100%;
      }
    `};
  transition: max-height 0.2s ease-in;
  > :last-child {
    margin-bottom: 0;
  }
`;

export default class DescriptionViewMore extends Component {
  static propTypes = {
    children: PropTypes.node,
    disable: PropTypes.bool
  };

  static defaultProps = {
    description: ''
  };

  state = {
    collapsed: true,
    hovering: false
  };

  setCollapsedStatus(collapsed) {
    this.setState({ collapsed });
  }

  render() {
    const { collapsed } = this.state;
    const { children, disable } = this.props;
    return (
      <div>
        <Collapse collapsed={!disable && collapsed}>{children}</Collapse>
        {!disable && (
          <MoreLabel secondary onClick={() => this.setCollapsedStatus(!collapsed)}>
            See {collapsed ? 'more' : 'less'}
          </MoreLabel>
        )}
      </div>
    );
  }
}
